<h2 mat-dialog-title class="tt-secondary-background" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container" cdkDragHandle style="color: white">
    <!-- {{ heading || "" }} -->
</h2>

<mat-dialog-content style="max-height: none; height: 100%; flex: 1; font-family: var(--tt-body-font-family); display: flex; flex-direction: column; color: var(--tt-body-text-color)">
    <tt-tabs [(ttSelectedId)]="activeTab" (ttSelectedIdChange)="onTabChanged($event)">
        <tt-tab *ngIf="!!data.translateLabel" ttId="input_label" ttLabel="input_label"></tt-tab>
        <tt-tab *ngIf="!!data.translateSublabel" ttId="input_sublabel" ttLabel="input_sublabel"></tt-tab>
        <tt-tab *ngIf="!!data.translateHelptext" ttId="input_helptext" ttLabel="input_helptext"></tt-tab>
    </tt-tabs>

    <div style="flex: 1; height: 100%; overflow: auto">
        <tt-translate-edit
            [hidden]="activeTab !== 'input_label'"
            *ngIf="!!data.translateLabel"
            [(ttTextToTranslate)]="inputLabel"
            [(ttTranslateEdits)]="labelEdits"
            [ttSave]="saveLabelTranslations"
        ></tt-translate-edit>
        <tt-translate-edit
            *ngIf="sublabelTabHasBeenSelected && !!data.translateSublabel"
            [hidden]="activeTab !== 'input_sublabel'"
            [(ttTextToTranslate)]="inputSublabel"
            [(ttTranslateEdits)]="sublabelEdits"
            [ttSave]="saveSublabelTranslations"
        ></tt-translate-edit>
        <tt-translate-edit
            *ngIf="helptextTabHasBeenSelected && !!data.translateHelptext"
            [hidden]="activeTab !== 'input_helptext'"
            [(ttTextToTranslate)]="inputHelptext"
            [(ttTranslateEdits)]="helptextEdits"
            [ttSave]="saveHelptextTranslations"
        ></tt-translate-edit>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <!-- <!-- <tt-button class="col-xs-2 sp-2 pull-right" ttText="create_acvoucher" ttType="success" (ttClick)="process('create_acvoucher')"></tt-button> -->
    <tt-button class="col-xs-2 sp-0" ttText="close" ttType="secondary" (ttClick)="close()" [ttDisabled]="dialog.disableClose === true"></tt-button>
</mat-dialog-actions>
